import { AddIcon, RemoveIcon } from '@medly-components/icons';
import { ZoneContext } from 'context/ZoneContext';
import { useContext, useEffect, useState } from 'react';
import { useControls } from 'react-zoom-pan-pinch';
import { ActionsContainer, ActionsGroup } from './Actions.styled';
import { mapScales } from 'pages/Map/MyMap/Map/constants';
import { MapTourContext } from 'context/MapTourContext';
import { TourType } from 'pages/Map/components/MapTour';
import { useTheme } from 'styled-components';
import { useIsMobile } from 'hooks';
import { Direction } from 'types';
import CurrentLocation from './CurrentLocation';

export const Actions = () => {
    const { mapState, scale } = useContext(ZoneContext);
    const { zoomIn, zoomOut } = useControls();
    const { colors } = useTheme();
    const { isCurrentTourItem } = useContext(MapTourContext);
    const { MAX_SCALE, MIN_SCALE, SCALE_STEPPER } = mapScales;

    const [showActions, setShowActions] = useState(true);
    const isMobile = useIsMobile();

    useEffect(() => {
        setShowActions(true);
    }, [isMobile]);

    useEffect(() => {
        if (!isMobile) {
            return;
        }
        if (mapState.current.scrollDirection === Direction.UP) {
            setShowActions(false);
        } else if (mapState.current.scrollDirection === Direction.DOWN) {
            setShowActions(true);
        }
    }, [mapState.current.scrollDirection]);

    if (!showActions) {
        return null;
    }

    return (
        <ActionsContainer isMapTourActiveElement={isCurrentTourItem(TourType.ZOOM_IN_ZOOM_OUT)}>
            <ActionsGroup>
                <AddIcon
                    style={{
                        borderBottom: `0.1rem solid ${colors.grey[300]}`,
                        borderRadius: '0'
                    }}
                    variant="solid"
                    data-testid="zoom-in-icon"
                    disabled={scale >= MAX_SCALE}
                    bgColor={colors.white}
                    iconColor={colors.darkBlue}
                    onClick={() => zoomIn(SCALE_STEPPER)}
                />
                <RemoveIcon
                    variant="solid"
                    data-testid="zoom-out-icon"
                    disabled={scale <= MIN_SCALE}
                    bgColor={colors.white}
                    iconColor={colors.darkBlue}
                    onClick={() => zoomOut(SCALE_STEPPER)}
                />
            </ActionsGroup>
            <CurrentLocation />
        </ActionsContainer>
    );
};
